import styled from 'styled-components';
const VizExCard = styled.div.withConfig({
  displayName: "VizExCard"
})(["position:relative;display:flex;flex-direction:column;margin-bottom:16px;width:100%;padding:0;background-color:white;box-shadow:0 1px 5px 0 rgba(45,62,80,0.12);border-radius:3px;"]);
export default VizExCard;